import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';

@Component({
  selector: 'app-notes-modal',
  templateUrl: './notes-modal.component.html',
  styleUrls: ['./notes-modal.component.css']
})
export class NotesModalComponent implements OnInit {

  @Input() trip: any;
  @Output() saveNotes = new EventEmitter<any>();
  @Output() close = new EventEmitter<void>();

  notesForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private assignTripService: AssigTripsService,

  ) { }

  ngOnInit(): void {
    console.log("trip,", this.trip);
    this.notesForm = this.fb.group({
      dispatchNoteTwo: [''],
      driverNote: ['']
    });

    if (this.trip) {
      this.notesForm.patchValue({
        dispatchNoteTwo: this.trip.dispatchNoteTwo,
        driverNote: this.trip.driverNote
      });
    }
  }

  onSubmit() {
    const payload: any = {
      _id: this.trip._id,
      dispatchNoteTwo: this.notesForm.value.dispatchNoteTwo,
      driverNote: this.notesForm.value.driverNote,
    };
    this.assignTripService.updateTrip(payload).subscribe(data => {
      if (data) {
        this.saveNotes.emit(data);
        console.log(data);
      }
    });
  }

  closeModal() {
    this.close.emit();
  }
}
